<template>
  <div class="d-inline">
    <b-button
        class="text-nowrap"
        size="sm"
        @click="showModal = true"
    >
      {{ $t('Add images') }}
      <fa class="ml-1" icon="file-upload" />
    </b-button>

    <b-modal
        v-model="showModal"
        :title="$t('Add images')"
        hide-footer
        no-close-on-backdrop
        size="xl"
        @show="form.reset()"
    >
      <b-form @submit.prevent="handleSubmit">
        <file-upload-form-group
            v-model="form.images"
            :invalid-feedback="form.errors.flatten().join('<br>')"
            :progress="form.progress"
            :state="form.errors.any() ? false : null"
            accept="image/*"
        />

        <b-button :disabled="form.busy || !form.images.length > 0" type="submit" variant="primary">
          {{ $t('Save') }}

          <b-spinner v-if="form.busy" small />
          <fa v-else class="ml-1" icon="save" />
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import FileUploadFormGroup from "@/components/FileUploadFormGroup"
import Form from '@/plugins/form'

export default {
  name: 'NewImagesModal',
  components: {FileUploadFormGroup},
  props: {
    disability: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: [],
      showModal: false,
      form: new Form({
        images: []
      }),
      // needs to be in sync with addImages@RoomDisabilitiesController.php
      maxFilesAmount: 10,
      allowedFileSize: 10000
    }
  },
  computed: {
    apiUrl() {
      return `/api/rooms/${this.disability.room_id}/disabilities/${this.disability.disability_id}/images`
    },
  },
  methods: {
    async handleSubmit() {
      if (this.form.busy) return;

      try {
        let {data} = await this.form.post(this.apiUrl);
        this.$emit('update:disability', data)

        this.showModal = false;
      } catch (e) {
        this.form.successful = false;
        this.form.progress = undefined;
        return e.response || throw e;
      }
    }
  }
}
</script>
